module.exports = __webpack_public_path__ + "static/media/multi-3.80fce988.png";